import { render, staticRenderFns } from "./kyc-pending-table.vue?vue&type=template&id=044632d8"
import script from "./kyc-pending-table.vue?vue&type=script&lang=js"
export * from "./kyc-pending-table.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports